import React from 'react';

import { Button } from 'components/Button';

import { ComponentProps } from './interfaces';
import * as Styled from './styled';

const wrapperAlignment = {
  left: Styled.Wrapper.LeftAligned,
  justify: Styled.Wrapper.JustifyAligned
};

export const TransactionActionPanel: React.FC<ComponentProps> = ({
  programOfAgency,
  programOfAgencyTitle,
  partnershipWithAgencies = [],
  partnershipWithAgenciesTitle,
  actions = [],
  agencyAlignment = 'left'
}) => {
  const Wrapper = wrapperAlignment[agencyAlignment];
  const ActionsContainer =
    agencyAlignment === 'left' ? Styled.FillActionsContainer : Styled.ActionsContainer;
  const hasPartnerAgency = partnershipWithAgencies && partnershipWithAgencies.length > 0;
  return (
    <Wrapper>
      <ActionsContainer>
        {actions &&
          actions.length > 0 &&
          actions.map(action => {
            const { id, label, onClick } = action;
            return (
              <Button key={id} onClick={onClick}>
                {label}
              </Button>
            );
          })}
      </ActionsContainer>
      <Styled.Divider />
      <Styled.ProgramAgencyContainer>
        <Styled.AgenciesTitle>{programOfAgencyTitle}</Styled.AgenciesTitle>
        {programOfAgency && (
          <Styled.AgencyLogo>
            <img src={programOfAgency.image} alt={programOfAgency.label} />
          </Styled.AgencyLogo>
        )}
      </Styled.ProgramAgencyContainer>
      {hasPartnerAgency && (
        <Styled.PartnerAgenciesContainer>
          <Styled.AgenciesTitle>{partnershipWithAgenciesTitle}</Styled.AgenciesTitle>
          <Styled.AgenciesGroup>
            {partnershipWithAgencies.map(agency => {
              const { id, label, image } = agency;
              return (
                <Styled.AgencyLogo key={id}>
                  <img src={image} alt={label} />
                </Styled.AgencyLogo>
              );
            })}
          </Styled.AgenciesGroup>
        </Styled.PartnerAgenciesContainer>
      )}
    </Wrapper>
  );
};

export default TransactionActionPanel;
